<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="RentalServices"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <VueSlickgrid
    :name="gridName"
    :headerTitle="'Rental services'|pgettext('RentalServices')"
    :items="ds"
    checkbox-row-selection
    export-to-csv
    :exportToCsvFilename="'rental-services'|pgettext('filename')"
    :columnDefaults="b_2248226175642056_columnDefaults"
    :columns="b_2248226175642056_columns"
    class="page--grid"
    ref="grid"
    @selectedRowsChanged="evh_2248226175642056_selectedRowsChanged($event, {})"
    @command="evh_2248226175642056_command($event, {})"
  >
    <DIV
      class="flex-grow-1 d-flex"
      slot="toolbar"
    >
      <DIV
        class="mx-2"
      >
        <ItpFormCheckbox
          name="skip_archived"
          :label="'Skip archived items'|pgettext('RentalServices')"
          inline
          v-model="dsParams.skip_archived"
        >
        </ItpFormCheckbox>
      </DIV>
      <DIV
        class="border-left px-4"
      >
        <ItpButton
          :disabled="!selectedItems || !selectedItems.length"
          :icon="$config.contract.createContractIcon"
          :text="'Bulk edit...'|pgettext('RentalServices')"
          size="sm"
          variant="light"
          @click="evh_4440454779651433_click($event, {})"
        >
        </ItpButton>
      </DIV>
    </DIV>
  </VueSlickgrid>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "rentalServices",
    path: "/rental-services",
    component: "RentalServices"
  }
)

@Component()
export default class RentalServices extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
    this.$$cache_dsParams = new ComponentValueCache(this, "dsParams", "RentalServices.dsParams");
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  gridName!: any;
  selectedItems!: any;
  dsParams!: any;
  ds!: any;

  async $$load_ds() {
    return this.$fn.slickDataSource('integro_api/browse_rental_service', {
      parameters: () => ({ ...this.dsParams, date: this.$fn.today() })
    })
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_2248226175642056_columnDefaults!: any;
  b_2248226175642056_columns!: any;
  dataMembers = ['gridName', 'selectedItems', 'dsParams', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        gridName: "rentalServices",
        selectedItems: [
        ]
        ,
        dsParams: {
          skip_archived: true,
        }
        ,
        ds: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_2248226175642056_columnDefaults: {
          sortable: true,
          filterable: true,
          resizable: true,
          selectable: true,
        }
        ,
        b_2248226175642056_columns: [{
          field: "contract_revision",
          name: this.$fn.pgettext("Contract", "Contract number"),
          params: {
            sortPath: "contract_revision.contract_number",
          }
          ,
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "getvalue",
              opts: {
                field: "contract_revision.contract_number",
                source: "row",
              }
              ,
            }
              ,
            {
              name: "routeLink",
              to: "contract",
              navigateOnIconClick: true,
              skipExport: true,
              params: {
                id: "contract_id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          id: "contract_type",
          field: "contract_revision",
          name: this.$fn.pgettext("RentalServices", "Type"),
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "getvalue",
              opts: {
                field: "contract_type",
                source: "value",
              }
              ,
            }
              ,
            {
              name: "gettext",
              context: "ContractTypes",
              conversion: "StartCase",
              filterInput: true,
            }
              ,
            {
              name: "badge",
              variantMapSource: "inputValue",
              variantmap: {
                rental: "contract-type--rental",
                vendor: "contract-type--vendor",
                rental_agreement: "contract-type--rental_agreement",
                service: "contract-type--service",
                parking: "contract-type--parking",
                unknown: "contract-type--unknown",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          id: "contract_status",
          field: "contract_revision",
          name: this.$fn.pgettext("RentalServices", "Status"),
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "getvalue",
              opts: {
                field: "status",
                source: "value",
              }
              ,
            }
              ,
            {
              name: "gettext",
              context: "ContractStatus",
              conversion: "StartCase",
              filterInput: true,
            }
              ,
            {
              name: "badge",
              variantMapSource: "fieldValue",
              variantmap: {
                draft: "light",
                approved: "success",
                signed: "success",
                active: "primary",
                ended: "warning",
                terminated: "warning",
                rescinded: "danger",
                archived: "light",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "rental",
          name: this.$fn.pgettext("RentalServices", "Rental"),
          type: "command",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <strong>{{ $value.name }}</strong>\n\
    {{~#if $value.house_number }} | {{ $value.house_number }}{{/if }}\n\
    {{~#if $value.area }} ({{$value.area}}{{$value.unit_of_area}}){{/if }}\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            {
              name: "routeLink",
              to: "rental",
              navigateOnIconClick: true,
              params: {
                id: "rental_id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "company",
          name: this.$fn.pgettext("Contract", "Company"),
          params: {
            sortPath: "company.name",
          }
          ,
          type: "command",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <strong title=\"{{ $value.name }}\">{{ $value.code }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            {
              name: "routeLink",
              to: "company",
              navigateOnIconClick: true,
              params: {
                id: "company.id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "counterparty",
          name: this.$fn.pgettext("Contract", "Counterparty"),
          params: {
            sortPath: "counterparty.name",
          }
          ,
          type: "command",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <strong title=\"{{ $value.name }}\">{{ $value.code }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            {
              name: "routeLink",
              to: "company",
              navigateOnIconClick: true,
              params: {
                id: "counterparty.id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "meter",
          name: this.$fn.pgettext("MeterConsumptionBrowser", "Meter"),
          type: "command",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <strong>{{ $value.serial_number }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            {
              name: "routeLink",
              to: "meter",
              navigateOnIconClick: true,
              params: {
                id: "meter.id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "valid_from",
          name: this.$fn.pgettext("RentalServices", "Valid From"),
          formatter: {
            name: "date",
          }
          ,
        }
          ,
        {
          field: "valid_to",
          name: this.$fn.pgettext("RentalServices", "Valid To"),
          formatter: {
            name: "date",
          }
          ,
        }
          ,
        {
          field: "meter_factor",
          name: this.$fn.pgettext("RentalServices", "Meter factor"),
          formatter: {
            name: "number",
          }
          ,
        }
          ,
        {
          field: "name",
          name: this.$fn.pgettext("ContractService", "Name"),
          type: "command",
        }
          ,
        {
          field: "intermediated_service",
          name: this.$fn.pgettext("ContractService", "Intermediated service"),
          formatter: "checkbox",
        }
          ,
        {
          field: "non_billable",
          name: this.$fn.pgettext("ContractService", "Non-billable"),
          formatter: "checkbox",
        }
          ,
        {
          field: "billing_unit",
          name: this.$fn.pgettext("ContractService", "Billing unit"),
        }
          ,
        {
          field: "tariff_code",
          name: this.$fn.pgettext("ContractService", "Taridd code"),
        }
          ,
        {
          field: "created_at",
          name: this.$fn.pgettext("BrowserColumn", "Create time"),
          formatter: "datetime",
        }
          ,
        ]
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.gettext("Rental services"),
        icon: this.$config.rental.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_8292_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_8292, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_setData_8294_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_2248226175642056_setData_8294, alias=undefined
    return {
      path: "selectedItems",
      value: this.$refs.grid.getSelectedItems(),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_2248226175642056_selectedRowsChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_reloadSlickgrid_8298_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_2248226175642056_reloadSlickgrid_8298, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async evh_2248226175642056_close_8297_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_close_8297, alias=undefined
    return $event.data.modalResult.ok
  }

  async act_2248226175642056_showModal_8296_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2248226175642056_showModal_8296, alias=undefined
    return {
      name: "RentalService",
      props: {
        modal: true,
        oid: $event.data.data.id,
      }
      ,
    }
  }

  async evh_2248226175642056_command_8295_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_command_8295, alias=undefined
    return $event.data.column.id === 'name'
  }

  async evh_2248226175642056_command(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_command.executeFromDOM(this, event, scope);
  }

  async act_4440454779651433_reloadSlickgrid_8302_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_4440454779651433_reloadSlickgrid_8302, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async evh_4440454779651433_close_8301_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_4440454779651433_close_8301, alias=undefined
    return $event.data.modalResult.ok
  }

  async act_4440454779651433_showModal_8300_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_4440454779651433_showModal_8300, alias=undefined
    return {
      name: "BulkRentalServiceEditor",
      props: {
        items: this.selectedItems,
      }
      ,
    }
  }

  async evh_4440454779651433_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4440454779651433_click.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_8292: actions.CloseModalAction;
    evh_7315092382398562_close_8291: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_setData_8294: actions.SetDataAction;
    evh_2248226175642056_selectedRowsChanged_8293: actions.EventHandlerImpl;
    evh_2248226175642056_selectedRowsChanged: actions.EventHandlerGroup;
    act_2248226175642056_reloadSlickgrid_8298: actions.ReloadSlickgridAction;
    evh_2248226175642056_close_8297: actions.EventHandlerImpl;
    act_2248226175642056_showModal_8296: actions.ShowModalAction;
    evh_2248226175642056_command_8295: actions.EventHandlerImpl;
    evh_2248226175642056_command: actions.EventHandlerGroup;
    act_4440454779651433_reloadSlickgrid_8302: actions.ReloadSlickgridAction;
    evh_4440454779651433_close_8301: actions.EventHandlerImpl;
    act_4440454779651433_showModal_8300: actions.ShowModalAction;
    evh_4440454779651433_click_8299: actions.EventHandlerImpl;
    evh_4440454779651433_click: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_8292 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_8292_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_8291 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_8292,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_8291],
      }
    );
    const act_2248226175642056_setData_8294 = new actions.SetDataAction(
      {
        actionArgs: this.act_2248226175642056_setData_8294_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_selectedRowsChanged_8293 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_setData_8294,
        event: "selectedRowsChanged",
        displayName: "setData",
      }
    );
    const evh_2248226175642056_selectedRowsChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_selectedRowsChanged_8293],
      }
    );
    const act_2248226175642056_reloadSlickgrid_8298 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_2248226175642056_reloadSlickgrid_8298_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_close_8297 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_reloadSlickgrid_8298,
        event: "close",
        when: this.evh_2248226175642056_close_8297_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_2248226175642056_showModal_8296 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2248226175642056_showModal_8296_getActionArgs,
        events: [evh_2248226175642056_close_8297],
      }
    );
    const evh_2248226175642056_command_8295 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_showModal_8296,
        event: "command",
        when: this.evh_2248226175642056_command_8295_getWhen,
        displayName: "showModal",
      }
    );
    const evh_2248226175642056_command = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_command_8295],
      }
    );
    const act_4440454779651433_reloadSlickgrid_8302 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_4440454779651433_reloadSlickgrid_8302_getActionArgs,
        events: [],
      }
    );
    const evh_4440454779651433_close_8301 = new actions.EventHandlerImpl(
      {
        action: act_4440454779651433_reloadSlickgrid_8302,
        event: "close",
        when: this.evh_4440454779651433_close_8301_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_4440454779651433_showModal_8300 = new actions.ShowModalAction(
      {
        actionArgs: this.act_4440454779651433_showModal_8300_getActionArgs,
        events: [evh_4440454779651433_close_8301],
      }
    );
    const evh_4440454779651433_click_8299 = new actions.EventHandlerImpl(
      {
        action: act_4440454779651433_showModal_8300,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_4440454779651433_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_4440454779651433_click_8299],
      }
    );
    return {
      act_7315092382398562_closeModal_8292,
      evh_7315092382398562_close_8291,
      evh_7315092382398562_close,
      act_2248226175642056_setData_8294,
      evh_2248226175642056_selectedRowsChanged_8293,
      evh_2248226175642056_selectedRowsChanged,
      act_2248226175642056_reloadSlickgrid_8298,
      evh_2248226175642056_close_8297,
      act_2248226175642056_showModal_8296,
      evh_2248226175642056_command_8295,
      evh_2248226175642056_command,
      act_4440454779651433_reloadSlickgrid_8302,
      evh_4440454779651433_close_8301,
      act_4440454779651433_showModal_8300,
      evh_4440454779651433_click_8299,
      evh_4440454779651433_click,
    }
  }
}

Vue.component("RentalServices", RentalServices);

</script>